import { Button } from "react-bootstrap";
import "../../assets/styles/users.scss";

const UsersButtons = ({ onSearch, onAdd, disabled = false }) => {
	return (
		<div className="sc-buttons">
			<Button
				className="sc-btn sc-btn-search sc-btn-iconOnly"
				variant="outline-secondary"
				aria-label="Szukaj"
				title="Szukaj"
				disabled={disabled}
				onClick={() => {
					if (typeof onSearch === "function") onSearch();
				}}
			>
				<span className="sc-btn-icon" aria-hidden="true">
					<i className="bi bi-search" />
				</span>
				<span className="sc-btn-label">Szukaj</span>
			</Button>

			<Button
				className="sc-btn sc-btn-accept sc-btn-iconOnly"
				variant="outline-success"
				aria-label="Dodaj"
				title="Dodaj"
				disabled={disabled}
				onClick={() => {
					if (typeof onAdd === "function") onAdd();
				}}
			>
				<span className="sc-btn-icon" aria-hidden="true">
					<i className="bi bi-plus-lg" />
				</span>
				<span className="sc-btn-label">Dodaj</span>
			</Button>
		</div>
	);
};

export default UsersButtons;